import {
    FieldArray,
    FieldArrayRenderProps,
} from 'formik';
import {
    ActionIcon,
    Button,
    Group,
    Stack,
    Table,
    Text,
    TextInput,
} from '@mantine/core';
import {
    AiOutlineDelete,
    AiOutlinePlus,
} from 'react-icons/ai';

import {StepInput} from '../types.ts';

// The key/value inputs for ONE step.
//
// ⚠️ TYPED SCALAR PAIRS ONLY. There is deliberately no JSON textarea here, and
// none should be added. `StepInputInput` is `{ key: String!, value: String! }` —
// a structured pair the executor reads directly. A blob field would move the
// shape out of the schema and into a string nobody validates, which is how the
// Action seam erodes: the executor would have to parse, and a malformed payload
// would surface as a runtime failure instead of a form error.
export const StepInputsField = (
    {
        stepIndex,
        inputs,
    }: {
        stepIndex: number,
        inputs: StepInput[],
    }) => {

    return (
        <FieldArray name={`steps.${stepIndex}.inputs`}>
            {({
                  push,
                  remove,
                  form,
              }: FieldArrayRenderProps) => (
                <Stack gap={'xs'}>
                    <Text size={'xs'} c={'dimmed'}>
                        Optional inputs passed to this action, as key/value pairs.
                    </Text>

                    {inputs.length > 0 ? (
                        <Table withTableBorder verticalSpacing={'xs'}>
                            <Table.Thead>
                                <Table.Tr>
                                    <Table.Th>Key</Table.Th>
                                    <Table.Th>Value</Table.Th>
                                    <Table.Th w={60}/>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                {inputs.map((input, inputIndex) => (
                                    <Table.Tr key={inputIndex}>
                                        <Table.Td>
                                            <TextInput
                                                aria-label={`Step ${stepIndex + 1} input ${inputIndex + 1} key`}
                                                placeholder='username'
                                                value={input.key}
                                                onChange={(event) =>
                                                    form.setFieldValue(
                                                        `steps.${stepIndex}.inputs.${inputIndex}.key`,
                                                        event.currentTarget.value,
                                                    )
                                                }
                                            />
                                        </Table.Td>
                                        <Table.Td>
                                            <TextInput
                                                aria-label={`Step ${stepIndex + 1} input ${inputIndex + 1} value`}
                                                placeholder='synthetic-user-1'
                                                value={input.value}
                                                onChange={(event) =>
                                                    form.setFieldValue(
                                                        `steps.${stepIndex}.inputs.${inputIndex}.value`,
                                                        event.currentTarget.value,
                                                    )
                                                }
                                            />
                                        </Table.Td>
                                        <Table.Td>
                                            <ActionIcon
                                                aria-label={`Remove step ${stepIndex + 1} input ${inputIndex + 1}`}
                                                variant='subtle'
                                                color='red'
                                                onClick={() => remove(inputIndex)}
                                            >
                                                <AiOutlineDelete/>
                                            </ActionIcon>
                                        </Table.Td>
                                    </Table.Tr>
                                ))}
                            </Table.Tbody>
                        </Table>
                    ) : null}

                    <Group>
                        <Button
                            size='xs'
                            variant='subtle'
                            leftSection={<AiOutlinePlus/>}
                            onClick={() => push({
                                                    key: '',
                                                    value: '',
                                                })}
                        >
                            Add Input
                        </Button>
                    </Group>
                </Stack>
            )}
        </FieldArray>
    );
};
